import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createSafeJSONStorage } from "./safeStorage";

interface Loading {
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

interface Notification {
  tickerCount: number;
  setTickerCount: (count: number) => void;
  type: string;
  notificationMessage: string;
  isNotificationShow: boolean;
  setType: (type: string) => void;
  setIsNotificationShow: (show: boolean) => void;
  setNotificationMessage: (msg: string) => void;
}

interface AppShell {
  isAsideShow: boolean;
  setIsAsideShow: (loading: boolean) => void;
}

interface RestaurantDetails {
  restaurant: any;
  restuarantName: string;
  setRestuarantName: (restaurantName: string) => void;
  setRestaurant: (restaurant: any) => void;
}

export const useRestuarantDetails = create<RestaurantDetails>()(
  persist(
    (set) => ({
      restaurant: {},
      restuarantName: "",
      setRestuarantName: (restaurantName: string) => {
        set({ restuarantName: restaurantName });
      },
      setRestaurant: (restaurant: any) => {
        set({ restaurant: restaurant });
      },
    }),
    {
      name: "restaurant-details",
      storage: createSafeJSONStorage(() => localStorage),
    }
  )
);

export const useUserInfoStore = create<any>()(
  persist(
    (set) => ({
      userInfo: {},
      setUserInfo: (userInfo: any) => {
        set({ userInfo: userInfo });
      },
    }),
    {
      name: "user-info",
      storage: createSafeJSONStorage(() => localStorage),
    }
  )
);

export const useLoading = create<Loading>((set) => ({
  isLoading: false,
  setIsLoading: (loading: boolean) => {
    set({ isLoading: loading });
  },
}));

export const useDrawer = create<any>((set: any) => ({
  additionalAddressModalOpened: false,
  cartModal: false,
  cartOpen: false,
  addressModalOpened: false,
  setAdditionalAddressModalOpened: (additionalAddressModalOpened: boolean) => {
    set({ additionalAddressModalOpened: additionalAddressModalOpened });
  },
  setAddressModalOpened: (addressModalOpened: boolean) => {
    set({ addressModalOpened: addressModalOpened });
  },
  setCartModal: (cartModal: boolean) => {
    set({ cartModal: cartModal });
  },
  setCartOpen: (open: boolean) => {
    set({ cartOpen: open });
  },
}));

export const useNotificationWindow = create<Notification>((set) => ({
  tickerCount: 0,
  setTickerCount: (count: number) => {
    set({ tickerCount: count });
  },
  isNotificationShow: false,
  type: "sucess",
  notificationMessage: "",
  setType: (type: string) => {
    set({ type: type });
  },
  setIsNotificationShow: (show: boolean) => {
    set({ isNotificationShow: show });
    setTimeout(() => {
      set({ isNotificationShow: false });
    }, 5000);
  },
  setNotificationMessage: (msg: string) => {
    set({ notificationMessage: msg });
    setTimeout(() => {
      set({ notificationMessage: "" });
    }, 5000);
  },
}));

export const useAppShellLayout = create<AppShell>((set) => ({
  isAsideShow: false,
  setIsAsideShow: (visibility: boolean) => {
    set({ isAsideShow: visibility });
  },
}));

export const useStepStore = create<any>()(
  persist(
    (set: any) => ({
      someThingChanged: false,
      activeStep: 0,
      setActiveStep: (step: any) => set({ activeStep: step }),
      setSomeThingChanged: (changed: any) => set({ someThingChanged: changed }),
      // Action to clear (reset) the state
      clearData: () => set({ activeStep: 0 }),
    }),
    {
      name: "step-store",
    }
  )
);

export const useToastStore = create<any>((set: any) => ({
  swiped: false,
  setSwiped: (swiped: any) => set({ swiped }),
  swipeDirection: "",
  setSwipeDirection: (swipeDirection: any) => set({ swipeDirection }),
}));
